import { render, staticRenderFns } from "./SiteCreateEdit.vue?vue&type=template&id=63b57958&"
import script from "./SiteCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SiteCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports